
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.63 4.353a7.947 7.947 0 00-6.478-2.31c-3.67.37-6.688 3.35-7.098 7.02C1.504 13.91 5.253 18 9.982 18a7.978 7.978 0 007.208-4.559c.32-.67-.16-1.44-.9-1.44-.37 0-.72.2-.88.53a5.993 5.993 0 01-6.798 3.31c-2.22-.49-4.009-2.3-4.479-4.52a6 6 0 015.849-7.318c1.66 0 3.139.69 4.219 1.78l-1.51 1.51c-.63.63-.19 1.71.7 1.71h3.59c.549 0 .999-.45.999-1v-3.59c0-.89-1.08-1.34-1.71-.71l-.64.65z","fill":"#fff"}})])
          )
        }
      }
    